import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getRem, typographyCaption, wordBreak } from './../../core';

const paddingSize = getRem('12px');

const StyledInputHelperText = styled.div`
  ${({ theme }) => typographyCaption(theme)}
  ${wordBreak}
    align-items: center;
  box-sizing: border-box;
  color: ${({ theme }) => theme.color.text.light.secondary.value};
  display: flex;
  margin-top: ${({ theme }) => theme.size.spacing.small.value};
  padding-left: ${paddingSize};
  padding-right: ${paddingSize};
`;

const StyledInputHelperTextContent = styled.span`
  width: 100%;
`;

// Component should be used with Input/TextArea fields
const InputHelperText = ({ dataTestId = undefined, id, isDisabled = false, text, ...other }) => (
  <StyledInputHelperText id={id} data-testid={dataTestId} {...other}>
    <StyledInputHelperTextContent data-testid={dataTestId ? `${dataTestId}-text` : undefined}>
      {text}
    </StyledInputHelperTextContent>
  </StyledInputHelperText>
);

InputHelperText.propTypes = {
  /** provides data-testid for functional tests */
  dataTestId: PropTypes.string,
  /** Unique identificator. Necessary to have for linking with other components */
  id: PropTypes.string.isRequired,
  /** If true, adjusts label styling */
  isDisabled: PropTypes.bool,
  /** Displays provided text */
  text: PropTypes.node.isRequired,
};

export { InputHelperText };
